// GoogleHotels.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const GoogleHotels = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=es",
    en: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=en",
    ru: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=ru",
    de: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=de",
    fr: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=fr",
    pt: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=pt",
    nl: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=nl",
  };

  return (
    <>
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <i className="bi bi-google"></i>
        <span className="tooltip-text fade">Google Hotels</span>
      </button>
      {showModal && (
        <LanguageModal
          title="Google Hotels"
          icon="bi bi-google"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default GoogleHotels;
